export default "__VITE_ASSET__CQvFGPlR__"